import { render, staticRenderFns } from "./catReport.vue?vue&type=template&id=be6f9c94&scoped=true&"
import script from "./catReport.vue?vue&type=script&lang=js&"
export * from "./catReport.vue?vue&type=script&lang=js&"
import style0 from "./catReport.vue?vue&type=style&index=0&id=be6f9c94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6f9c94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard})
